import { Injectable } from '@angular/core';


@Injectable()
export class Variables {
    appName: string;
    version: string;
    timeout: any;
    retry: any;
    appGuid: string;
    constructor() {
        this.appName = "Bolão da Geral";
        this.timeout = 30000;
        this.retry = 0;
        this.appGuid = "199e8780-f724-4c97-a53e-8d8bf25dedb7";
    }
    //public static baseUrl: string = "http://localhost:13112/";
    //public static baseUrl: string = "http://service.bolaodageral.com.br/";
    public static baseUrl: string = "https://copa.bolaodageral.com.br/";
    public static championshipId: number = 0;
    public static ticketId: number = 0;
    public static version: string = "1.0.0 Copa";
}


// WEBPACK FOOTER //
// ./src/providers/variables.ts